import { FieldTemplateProps } from "@rjsf/core"
import { Help, Text, ValidationError } from "dash-styled"

export const TableHeaderParameterTemplate = (props: FieldTemplateProps) => {
    return (
        <div className="flex items-center justify-between w-full">
            {props.label && (
                <div className="flex items-center">
                    <Text>
                        {props.label}
                        {props.required ? "*" : ""}
                    </Text>
                    {props.rawDescription && (
                        <Help
                            className="ml-2"
                            text={props.rawDescription}
                            tooltipPlacement="bottom"
                        />
                    )}
                </div>
            )}
            <div className="w-2/3">
                {props.children}
                {props.rawErrors?.map((error, i) => (
                    <ValidationError key={i} className="mr-1">
                        {error === "is a required property"
                            ? "Please fill this out"
                            : error}
                    </ValidationError>
                ))}
            </div>
        </div>
    )
}
